import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c35fe074"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "acCookie_notification",
  class: "acCookie",
  "data-cy": "acCookie_modal"
}
const _hoisted_2 = { class: "acCookie_wrapper" }
const _hoisted_3 = { class: "acCookie_content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "acCookie_row acCookie_title" }, " Куки это важно, куки это нужно. ", -1))
const _hoisted_5 = { class: "acCookie_row acCookie_text" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "acCookie_actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_cookie_modal_block = _resolveComponent("cookie-modal-block")!
  const _component_cookie_modal_content = _resolveComponent("cookie-modal-content")!
  const _component_ac_modal = _resolveComponent("ac-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.$t('cookie.agreement')) + " ", 1),
            (_ctx.cookiePolicyLink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.cookiePolicyLink
                }, _toDisplayString(_ctx.$t('cookie.policy')), 9, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_ac_button, {
            class: "acCookie_button",
            "data-cy": "acCookie_modal_dismiss",
            variant: "outlined",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accept('dismiss')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cookie.dismiss')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_ac_button, {
            class: "acCookie_button",
            "data-cy": "acCookie_modal_settings",
            variant: "outlined",
            onClick: _ctx.settings
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cookie.settings')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ac_button, {
            class: "acCookie_button",
            "data-cy": "acCookie_modal_accept",
            variant: "outlined",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.accept('acceptAll')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('cookie.agreeAll')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 512), [
      [_vShow, _ctx.isShow]
    ]),
    (_ctx.isShowModal)
      ? (_openBlock(), _createBlock(_component_ac_modal, {
          key: 0,
          "model-value": true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_cookie_modal_content, {
              onClose: _ctx.closeSettings,
              onAccept: _cache[3] || (_cache[3] = ($event: any) => (_ctx.accept('accept'))),
              onDismiss: _cache[4] || (_cache[4] = ($event: any) => (_ctx.accept('dismiss'))),
              "show-title": "",
              "show-close-btn": ""
            }, {
              blocks: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mappedCookies, (cookie, key) => {
                  return (_openBlock(), _createBlock(_component_cookie_modal_block, {
                    key: `cookiePolicy-${key}`,
                    cookie: cookie,
                    onToggle: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleCookie($event)))
                  }, null, 8, ["cookie"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onClose"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}